import { replayIntegration, browserTracingIntegration } from "@sentry/angular";

export const SENTRY_CLIENT_CONFIG = {
    integrations: [
        browserTracingIntegration(),
        replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
};
